module.exports = __webpack_public_path__ + "static/img/7452e6a0-5528-4aca-8e4c-7dfb51ee23e6.95d8528.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/7452e6a0-5528-4aca-8e4c-7dfb51ee23e6.png
// module id = 8SXU
// module chunks = 0